module.exports = __webpack_public_path__ + "static/media/gitee-fill-round.bfb8af96.png";